/***
 * デバイス ユーザーエージェントから取得し、タブレット / モバイル / PC の判定を行う
 * html に クラスで ist-device-- を付与する
 *
 * 注意) iOS 13以降のiPadを判定するユーザーエージェント
 * - Safari設定の「デスクトップ用Webサイトを表示」がオンの場合、UAが「macintosh」となる
 * - タッチ機能の有無と組み合わせて判定する必要がある
 */
export class Device {
  private readonly DEVICE_CLASSES = {
    MOBILE: 'ist-device--mobile',
    TABLET: 'ist-device--tablet',
    PC: 'ist-device--pc',
  };

  constructor() {
    this.init();
  }

  private init(): void {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.detectDevice();
      });
    } else {
      this.detectDevice();
    }
  }

  private detectDevice(): void {
    const html = document.documentElement;

    // デバイス判定
    const isTablet = this.isTablet();
    const isMobile = this.isMobile();

    // クラス付与
    if (isTablet) {
      html.classList.add(this.DEVICE_CLASSES.TABLET);
    } else if (isMobile) {
      html.classList.add(this.DEVICE_CLASSES.MOBILE);
    } else {
      html.classList.add(this.DEVICE_CLASSES.PC);
    }
  }

  private isTablet(): boolean {
    const ua = navigator.userAgent.toLowerCase();

    // iPadの判定（iOS 13以降対応）
    // macintoshかつタッチ機能ありの場合もiPadとして判定
    const isiPad = /ipad|macintosh/.test(ua) && 'ontouchend' in document;

    // その他のタブレット判定（Android tablet等）
    const isOtherTablet = /android/.test(ua) && !/mobile/.test(ua);

    return isiPad || isOtherTablet;
  }

  private isMobile(): boolean {
    const ua = navigator.userAgent.toLowerCase();
    return /iphone|ipod|android.*mobile/.test(ua);
  }

  public getDeviceType(): string {
    if (
      document.documentElement.classList.contains(this.DEVICE_CLASSES.TABLET)
    ) {
      return 'tablet';
    } else if (
      document.documentElement.classList.contains(this.DEVICE_CLASSES.MOBILE)
    ) {
      return 'mobile';
    }
    return 'pc';
  }
}

export const device = new Device();
